/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clinicautocomplete_Typetosearch3Inputs */

const en_clinicautocomplete_typetosearch3 = /** @type {(inputs: Clinicautocomplete_Typetosearch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type a clinic name to search...`)
};

const fr_clinicautocomplete_typetosearch3 = /** @type {(inputs: Clinicautocomplete_Typetosearch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapez le nom d'une clinique...`)
};

/**
* | output |
* | --- |
* | "Type a clinic name to search..." |
*
* @param {Clinicautocomplete_Typetosearch3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const clinicautocomplete_typetosearch3 = /** @type {((inputs?: Clinicautocomplete_Typetosearch3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clinicautocomplete_Typetosearch3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clinicautocomplete_typetosearch3(inputs)
	return fr_clinicautocomplete_typetosearch3(inputs)
});
export { clinicautocomplete_typetosearch3 as "clinicAutocomplete_typeToSearch" }